import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

interface TooltipContextValue {
  delayDuration: number;
  skipDelayDuration: number;
  disableHoverableContent: boolean;
}

const TooltipContext = React.createContext<TooltipContextValue>({
  delayDuration: 0,
  skipDelayDuration: 0,
  disableHoverableContent: false,
});

export const useTooltipContext = () => {
  const context = React.useContext(TooltipContext);
  if (!context) {
    throw new Error("useTooltipContext must be used within a TooltipProvider");
  }
  return context;
};

interface TooltipProviderProps {
  children: React.ReactNode;
  delayDuration?: number;
  skipDelayDuration?: number;
  disableHoverableContent?: boolean;
}

export function AppTooltipProvider({
  children,
  delayDuration = 0,
  skipDelayDuration = 0,
  disableHoverableContent = false,
}: TooltipProviderProps) {
  const value = React.useMemo(
    () => ({
      delayDuration,
      skipDelayDuration,
      disableHoverableContent,
    }),
    [delayDuration, skipDelayDuration, disableHoverableContent]
  );

  return (
    <TooltipContext.Provider value={value}>
      <TooltipPrimitive.Provider
        delayDuration={delayDuration}
        skipDelayDuration={skipDelayDuration}
        disableHoverableContent={disableHoverableContent}
      >
        {children}
      </TooltipPrimitive.Provider>
    </TooltipContext.Provider>
  );
}
